import analyticsService from '@/services/api/analytics.js'

// PODCAST_DOWNLOADS
export const fetchPodcastDownloads = (
  context,
  service = analyticsService
) => (
  { podcastId, options },
  successAction,
  errorAction
) => service.getDownloads({
  ...options,
  podcast: podcastId
})
  .then(response => {
    successAction(context, { podcastId, options, response })
  })
  .catch(error => {
    errorAction(context, { podcastId, options, error })
  })

// EPISODE_DOWNLOADS
export const fetchEpisodeDownloads = (
  context,
  service = analyticsService
) => (
  { episodeId, options },
  successAction,
  errorAction
) => service.getDownloads({
  ...options,
  episode: episodeId
})
  .then(response => {
    successAction(context, { episodeId, options, response })
  })
  .catch(error => {
    errorAction(context, { episodeId, options, error })
  })
